<script>
import quit from "@/common/quit";
export default {
  data() {
    const username = localStorage.getItem("username");
    const userId = this.$cookie.get("id");
    const type = this.$route.params.type;
    let changeUserPhone = false;
    let changeUserPassword = false;
    if (type === "phone") {
      changeUserPhone = true;
    } else if (type === "password") {
      changeUserPassword = true;
    }
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length > 32) {
        return callback(new Error("密码长度不应超过32位"));
      } else if (value.length < 6) {
        return callback(new Error("密码长度不应小于6位"));
      } else {
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formChangePassword.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else if (value.length > 32) {
        return callback(new Error("密码长度不应超过32位"));
      } else if (value.length < 6) {
        return callback(new Error("密码长度不应小于6位"));
      } else {
        callback();
      }
    };
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      setTimeout(() => {
        if (!/^1(3|5|6|7|8|9)\d{9}$/.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      formChangePhone: {
        oraignNumber: username || undefined,
        newNumber: undefined,
        verification: undefined
      },
      rules: {
        oraignNumber: [
          {
            required: true,
            validator: validateMobile,
            trigger: "change"
          }
        ],
        newNumber: [
          {
            required: true,
            validator: validateMobile,
            trigger: "change"
          }
        ],
        verification: [
          { required: true, message: "请填写验证码", trigger: "change" }
        ],
        oldPassword: [
          {
            required: true,
            message: "请填写原密码",
            trigger: "change"
          }
        ],
        newPassword: [
          {
            required: true,
            validator: validatePass,
            trigger: "change"
          }
        ],
        repetition: [
          {
            required: true,
            validator: validatePass2,
            trigger: "change"
          }
        ]
      },
      formChangePassword: {
        newPassword: undefined,
        repetition: undefined,
        oldPassword: undefined
      },
      changeUserPhone,
      changeUserPassword,
      sendMsgButton: true,
      sendMsgButtonTime: 0,
      userId
    };
  },
  methods: {
    logout() {
      sessionStorage.clear();
      quit();
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (formName === "formChangePhone") {
            const data = {
              phone: this.formChangePhone.oraignNumber,
              newPhone: this.formChangePhone.newNumber,
              code: this.formChangePhone.verification,
              action: "VERIFY_MODIFY_PHONE"
            };
            const userId = this.userId;
            const result = await this.$http.updateLoninUserInfo(
              "verifySms",
              data,
              userId
            );
            if (result) {
              this.$message.success("更改成功！，请重新登录！");
              this.logout();
            }
          } else if (formName === "formChangePassword") {
            const data = {
              modifyPassword: this.formChangePassword.newPassword,
              oldPassword: this.formChangePassword.oldPassword
            };
            const userId = this.userId;
            const result = await this.$http.updateLoninUserInfo(
              "updatePwd",
              data,
              userId
            );
            if (result) {
              this.$message.success("更改成功！，请重新登录！");
              this.logout();
            }
          }
        } else {
          return false;
        }
      });
    },
    clickUserInfo() {
      this.$router.push({
        path: `/index/userinfo`
      });
    },
    async onClickSendMsg() {
      if (
        this.formChangePhone.newNumber &&
        /^1(3|5|7|8|9)\d{9}$/.test(this.formChangePhone.newNumber)
      ) {
        const data = {
          phone: this.formChangePhone.newNumber,
          action: "MODIFY_PHONE"
        };
        const result = await this.$http.updateLoninUserInfo("sendSms", data);
        if (result) {
          this.sendMsgButton = false;
          this.sendMsgButtonTime = 60;
          var auth_timetimer = setInterval(() => {
            this.sendMsgButtonTime--;
            if (this.sendMsgButtonTime <= 0) {
              this.sendMsgButton = true;
              clearInterval(auth_timetimer);
            }
          }, 1000);
        } else {
          this.$message.warning("发送验证码失败，请检查新手机号！");
        }
      } else {
        this.$message.success("新手机号未填写或格式不正确，请检查新手机号！");
      }
    }
  }
};
</script>

<template>
  <div class="updateUserInfoPage">
    <el-breadcrumb class="UserinfoDetailHeader" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>
        当前位置：
        <span class="userDetailPosition" @click="clickUserInfo">用户信息</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="changeUserPhone">修改手机号</el-breadcrumb-item>
      <el-breadcrumb-item v-if="changeUserPassword">修改密码</el-breadcrumb-item>
    </el-breadcrumb>
    <div v-if="changeUserPhone" class="changeUserPhoneView">
      <el-form
        label-position="right"
        :rules="rules"
        label-width="110px"
        :model="formChangePhone"
        ref="formChangePhone"
      >
        <el-form-item label="原手机号：" prop="oraignNumber">
          <el-input
            class="basicFormInput"
            v-model="formChangePhone.oraignNumber"
            placeholder="请输入原手机号"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="新手机号：" prop="newNumber">
          <el-input
            class="basicFormInput"
            v-model="formChangePhone.newNumber"
            placeholder="请输入新手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="verification">
          <el-input
            class="sendMsgFormInput"
            v-model="formChangePhone.verification"
            placeholder="手机验证码"
          ></el-input>
          <el-button
            type="primary"
            v-if="sendMsgButton"
            class="operationButton"
            size="middle"
            @click="onClickSendMsg"
          >获取验证码</el-button>
          <el-button v-else size="middle" @click="onClickSendMsg" :disabled="!sendMsgButton">
            <span class="auth_text_blue">{{sendMsgButtonTime}}</span> 秒之重新发送验证码
          </el-button>
        </el-form-item>
        <el-alert
          class="DialogAlert"
          title="验证码将发送到用户的新手机上"
          type="warning"
          show-icon
          :closable="false"
        ></el-alert>
        <el-form-item>
          <el-button
            class="operationButton submitButton"
            type="primary"
            @click="submitForm('formChangePhone')"
          >提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="changeUserPassword" class="changeUserPasswordView">
      <el-form
        label-position="right"
        :rules="rules"
        label-width="110px"
        :model="formChangePassword"
        ref="formChangePassword"
      >
        <el-form-item label="原密码：" prop="oldPassword">
          <el-input
            class="basicFormInput"
            type="password"
            show-password
            v-model="formChangePassword.oldPassword"
            placeholder="密码长度不小于6位"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPassword">
          <el-input
            class="basicFormInput"
            type="password"
            show-password
            v-model="formChangePassword.newPassword"
            placeholder="密码长度不小于6位"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码确认：" prop="repetition">
          <el-input
            class="basicFormInput"
            type="password"
            show-password
            v-model="formChangePassword.repetition"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="operationButton submitButton"
            type="primary"
            @click="submitForm('formChangePassword')"
          >提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.updateUserInfoPage {
  .UserinfoDetailHeader {
    line-height: 50px;
    margin-left: 25px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(89, 96, 99, 1);
    .userDetailPosition {
      color: #00c1de;
      cursor: pointer;
    }
  }
  .changeUserPhoneView {
    padding: 29px 26px 29px 29px;
    .el-form-item__error {
      left: 25px;
    }
  }
  .changeUserPasswordView {
    padding: 29px 26px 29px 29px;
    .el-form-item__error {
      left: 25px;
    }
  }

  .basicFormInput {
    width: 300px;
    margin: 0 25px;
  }
  .sendMsgFormInput {
    width: 160px;
    margin: 0 25px;
  }
  .operationButton {
    background-color: #00c1de;
    border-color: #00c1de;
  }
  .submitButton {
    margin-left: 25px;
  }

  .DialogAlert {
    margin: 15px 0 15px 135px;
    width: 306px;
    padding-left: 10px;
    height: 36px;
    background: rgba(255, 251, 230, 1);
    border-radius: 4px;
    border: 1px solid rgba(255, 229, 143, 1);

    .el-alert__title {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userinfo/updaetUserInfo.vue